exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#toaster[data-v-a2362d22]{position:absolute;bottom:2em;right:2em;z-index:1100}#toaster>ul[data-v-a2362d22]{padding-left:0;margin-bottom:0;list-style:none}.toasts-list-item[data-v-a2362d22]{transition:all .3s}.toasts-list-enter[data-v-a2362d22],.toasts-list-leave-to[data-v-a2362d22]{opacity:0;transform:translateX(30px)}", ""]);

// exports
